export const ADD_WAREHOUSE_REQUEST = "ADD_WAREHOUSE_REQUEST";
export const ADD_WAREHOUSE_SUCCESS = "ADD_WAREHOUSE_SUCCESS";
export const ADD_WAREHOUSE_FAIL = "ADD_WAREHOUSE_FAIL";

export const FETCH_WAREHOUSE_REQUEST = "FETCH_WAREHOUSE_REQUEST";
export const FETCH_WAREHOUSE_SUCCESS = "FETCH_WAREHOUSE_SUCCESS";
export const FETCH_WAREHOUSE_FAIL = "FETCH_WAREHOUSE_FAIL";


export const UPDATE_WAREHOUSE_STATUS_REQUEST = "UPDATE_WAREHOUSE_STATUS_REQUEST";
export const UPDATE_WAREHOUSE_STATUS_SUCCESS = "UPDATE_WAREHOUSE_STATUS_SUCCESS";
export const UPDATE_WAREHOUSE_STATUS_FAIL = "UPDATE_WAREHOUSE_STATUS_FAIL";
 
export const MONTH_END_REQUEST = "MONTH_END_REQUEST";
export const MONTH_END_SUCCESS = "MONTH_END_SUCCESS";
export const MONTH_END_FAIL = "MONTH_END_FAIL";
